import { Injectable } from '@angular/core';
import { BaseServiceWithFilter } from '.';
import { RouteType } from '@cl/shared/models/route-type.model';
import { BaseFilterModel } from '@cl/shared/models/base/base-filter-model.model';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class RouteTypesService extends BaseServiceWithFilter<RouteType, BaseFilterModel> {
    constructor(protected httpClient: HttpClient) {
        super(httpClient, '/api/v1/route-types/');
    }

    toString(object: RouteType): string {
        return object.name;
    }
}
